import React, { useState, useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { DownloadOutlined, FilterOutlined } from "@ant-design/icons";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import XLSX from "xlsx";

const Datatable = ({
  title,
  data,
  handleDelete,
  rowClick,
  selection,
  hideColumn,
  initializeSelectedRow,
  handleEdit,
  handleDetail,
  filterButton,
  download,
  addTittle,
}) => {
  const [selectedRowID, setSelectedRowID] = useState([]);
  const [tableIndex, setTableIndex] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    if (initializeSelectedRow) {
      setSelectedRowID(initializeSelectedRow);
    }
  }, []);
  const columns = [];

  const rowSelection = {
    selectedRowKeys: selectedRowID,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };

  if (data.length > 0) {
    Object.keys(data[0]).forEach((e) => {
      let deleteIndex = -1;

      if (hideColumn) {
        deleteIndex = hideColumn.findIndex((x) => x == e);
      }

      if (e !== "key" && deleteIndex == -1) {
        columns.push({
          title: e.toUpperCase().replace(/_/g, " "),
          dataIndex: e.toString(),
          key: e.toString(),
          ...getColumnSearchProps(e.toString()),
          sorter: (a, b) => {
            if (isNaN(a[e])) {
              return a[e].localeCompare(b[e]);
            } else {
              return a[e] - b[e];
            }
          },
          sortDirections: ["descend", "ascend"],
        });
      }
    });

    if (handleEdit) {
      columns.push({
        title: "EDIT",
        key: "key",
        dataIndex: "key",
        render: (text, record) => {
          return (
            <>
              {
                <Space size="middle" className="m-auto">
                  <Button
                    type="link"
                    icon={<EditOutlined />}
                    onClick={(e) => handleEdit(record)}
                  />
                </Space>
              }
            </>
          );
        },
      });
    }

    if (handleDelete) {
      columns.push({
        title: "EDIT",
        key: "key",
        dataIndex: "key",
        render: (text, record) => {
          return (
            <>
              {
                <Space size="middle" className="m-auto">
                  <Button
                    type="link"
                    icon={<DeleteOutlined />}
                    onClick={(e) => handleDelete(record)}
                  />
                </Space>
              }
            </>
          );
        },
      });
    }

    if (handleDetail) {
      columns.push({
        title: "DETAIL",
        key: "key",
        dataIndex: "key",
        render: (text, record) => (
          <Space size="middle" className="m-auto">
            <a className="text-red" onClick={(e) => handleDetail(record)}>
              View
            </a>
          </Space>
        ),
      });
    }
  }

  const downloadData = () => {
    let newData = [];
    download.filter((value) => {
      delete value.key;
      newData.push(value);
    });
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(newData);
    XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    addTittle
      ? XLSX.writeFile(workBook, `${addTittle}.xlsx`)
      : XLSX.writeFile(workBook, `${title}.xlsx`);
  };

  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex.replace(/_/g, " ")}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : null,
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          // setTimeout(() => this.searchInput.select());
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text}
          />
        ) : (
          text
        ),
    };
  }

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText("");
  }

  function onSelectChange(isSelected, selectedRow) {
    setSelectedRowID(isSelected);
    selection(selectedRow);
  }

  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="d-flex justify-content-start">
            <b>{title}</b>
            {filterButton && data.length > 0 ? (
              <Button
                type=""
                icon={<FilterOutlined />}
                size={"large"}
                style={{ float: "left" }}
                onClick={() => {
                  setTableIndex(tableIndex + 1);
                }}
              >
                Reset Filter
              </Button>
            ) : null}
          </div>
        </div>
        {download && data.length > 0 ? (
          <div className="col-6">
            <Button
              type=""
              icon={<DownloadOutlined />}
              size={"large"}
              style={{ float: "right" }}
              onClick={() => downloadData()}
            >
              Download
            </Button>
          </div>
        ) : null}
      </div>
      {selection ? (
        <Table
          key={tableIndex}
          style={{ whiteSpace: "nowrap" }}
          scroll={{ x: 400 }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                if (rowClick) {
                  rowClick(record);
                }
              }, // click row
            };
          }}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
          size="middle"
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
        />
      ) : (
        <Table
          key={tableIndex}
          style={{ whiteSpace: "nowrap" }}
          scroll={{ x: 400 }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                if (rowClick) {
                  rowClick(record);
                }
              }, // click row
            };
          }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
          columns={columns}
          dataSource={data}
          size="middle"
        />
      )}
    </>
  );
};

Datatable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
  rowClick: PropTypes.func,
  selection: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  hideColumn: PropTypes.array,
  initializeSelectedRow: PropTypes.array,
  handleEdit: PropTypes.func,
  handleDetail: PropTypes.func,
};

export default Datatable;
